const DIFFERENTIALS = [
  {
    icon: "ri-user-heart-line",
    title: "Atendimento Personalizado",
    desc: "Cada cliente recebe atenção exclusiva, com soluções pensadas para suas necessidades específicas.",
  },
  {
    icon: "ri-eye-line",
    title: "Transparência Total",
    desc: "Comunicação clara em todas as etapas, sem surpresas. Você acompanha tudo em tempo real.",
  },
  {
    icon: "ri-team-line",
    title: "Equipe Técnica Qualificada",
    desc: "Profissionais especializados com experiência comprovada em engenharia e arquitetura.",
  },
  {
    icon: "ri-checkbox-circle-line",
    title: "Soluções Completas",
    desc: "Do projeto à regularização, oferecemos tudo que seu imóvel precisa em um só lugar.",
  },
  {
    icon: "ri-time-line",
    title: "Prazos Garantidos",
    desc: "Comprometimento real com cronogramas estabelecidos, respeitando seu planejamento.",
  },
];

export default function DifferentialsSection() {
  return (
    <section className="py-24" style={{ backgroundColor: "#1F1F1F" }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#C9A24A] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Por que nos escolher
          </span>
          <h2 className="text-white font-bold text-4xl md:text-5xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Nossos Diferenciais
          </h2>
          <div className="w-16 h-1 mx-auto bg-[#C9A24A]" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
          {DIFFERENTIALS.map((item) => (
            <div
              key={item.title}
              className="border border-white/10 rounded-xl p-7 hover:border-[#C9A24A]/50 hover:bg-white/5 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-3xl`} style={{ color: "#C9A24A" }} />
              </div>
              <h3 className="text-white font-bold text-[17px] mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {item.title}
              </h3>
              <p className="text-white/65 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
